/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './progress-spinner-module';
export {
  MatProgressSpinner,
  MatSpinner,
  MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
  ProgressSpinnerMode,
  MatProgressSpinnerDefaultOptions,
  MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY,
} from './progress-spinner';
